// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#setInactiveModal p {
  margin-bottom: 0.64rem;
}
#setInactiveModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#setInactiveModal .container.radio {
  width: fit-content !important;
  padding: 0 50px;
}
#setInactiveModal .checkmark {
  margin-left: -26px;
  margin-top: 3px;
}
#setInactiveModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#setInactiveModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#setInactiveModal .btn-link:focus {
  text-decoration: none;
}
#setInactiveModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#setInactiveModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#setInactiveModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#setInactiveModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#setInactiveModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#setInactiveModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#setInactiveModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#setInactiveModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
